import { ValueAggregation } from '@g17eco/core';
import { HistoryData } from '../types/disaggregation';
import { g17ecoApi, transformResponse } from './g17ecoApi';
import { UtrAggregationConfig } from '@g17eco/types/universalTracker';

export interface DisaggregationResponse {
  valueAggregation: ValueAggregation;
  aggregationConfig: UtrAggregationConfig;
  disaggregatedData: HistoryData[];
}

export const disaggregationApi = g17ecoApi
  .enhanceEndpoints({
    addTagTypes: ['disaggregation'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDisaggregationByUtrvId: builder.query<DisaggregationResponse, string>({
        transformResponse,
        query: (utrvId) => ({
          url: `/universal-tracker-values/${utrvId}/disaggregation`,
          method: 'get',
        }),
        providesTags: ['disaggregation'],
      }),
    }),
  });

export const { useLazyGetDisaggregationByUtrvIdQuery, useGetDisaggregationByUtrvIdQuery } = disaggregationApi;
